import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getCategory, updateCategory } from "../../store/slice/categorySlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const DeleteCategoryModal = ({
  deleteModal,
  deleteId,
  handleClose,
  setDeleteModal,
  setDeleteId,
  pageNumber,
  totalCount,
}) => {
  const showHideClassName = deleteModal && "user_detail_modal_show";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const deleteCategoryHandler = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updateCategory({
        data,
        id: deleteId,
        cb: (err, res) => {
          if (err) {
            // console.log("err", err);
          } else {
            setDeleteModal(false);
            setDeleteId("");
            toast.error(t("toast.delete_category"), {
              autoClose: 3000,
            });
            if (
              totalCount &&
              totalCount[totalCount?.length - 1] == 1 &&
              +pageNumber !== 1
            ) {
              navigate(`/category/page/${pageNumber - 1}`);
            } else {
              dispatch(
                getCategory({ start: (pageNumber - 1) * 10, limit: 10 })
              );
            }
          }
        },
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            {t("modal.delete.delete_category")}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.delete_category_desc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deleteCategoryHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteCategoryModal;
